import React, {useState, useEffect} from 'react';
import {Box, Button, Grid, makeStyles, Typography} from '@material-ui/core';
import clsx from 'clsx';
import UserItem from '../../components/UserItem';
import {useDispatch, useSelector} from 'react-redux';
import {isStringEmpty} from '../../util/value';
import {addNotification} from '../../redux/actions';
import api from '../../services/api';
import Text from '../../components/fields/Text';
import PhoneInput from 'react-phone-input-2';

const useStyles = makeStyles((theme) => ({
  contentTitleUsers: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  subtitle: {
    marginBottom: theme.spacing(2),
  },
  subtitleBold: {
    fontWeight: 700,
  },
}));

function UserCreate({onCreate}) {
  const [value, setValue] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone_country_code: '57',
    phone: '',
    dni: '',
  });

  const dispatch = useDispatch();

  function handleCreate() {
    const fieldRequired = ['first_name', 'last_name', 'email', 'phone_country_code', 'phone', 'dni'];

    for (let i = fieldRequired.length - 1; i >= 0; i--) {
      if (isStringEmpty(value[fieldRequired[i]])) {
        dispatch(addNotification(`El campo "${fieldRequired[i]}" es requerido.`, 'error'));
        return;
      }
    }

    api.users
      .create(
        {
          first_name: value.first_name,
          last_name: value.last_name,
          email: value.email,
          phone_country_code: value.phone_country_code,
          phone: value.phone,
          dni: value.dni,
          person_type: 'legal',
        },
        {query: {$client: {owner_company: 'true'}}},
      )
      .then((it) => {
        if (onCreate) {
          onCreate(it);
        }
      });
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} md={4}>
        <Text
          name={'first_name'}
          label="Nombre"
          value={value.first_name}
          onChange={(e) => {
            setValue({...value, first_name: e.target.value});
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <Text
          name={'last_name'}
          label="Apellido"
          value={value.last_name}
          onChange={(e) => {
            setValue({...value, last_name: e.target.value});
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <Text
          name={'email'}
          label="Correo electrónico"
          value={value.email}
          onChange={(e) => {
            setValue({...value, email: e.target.value});
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PhoneInput
          masks={{co: '(...) ... ....'}}
          specialLabel={''}
          value={`${value.phone_country_code}${value.phone}`}
          country={value.phone_country_code}
          name="phone"
          inputStyle={{
            width: '100%',
            border: '1px solid #e2e2e1',
            backgroundColor: '#fcfcfb',
            height: 58,
          }}
          containerStyle={{
            width: '100%',
          }}
          onChange={(phone, {dialCode: phone_country_code}) => {
            setValue({
              ...value,
              phone: phone.substr(phone_country_code.length),
              phone_country_code,
            });
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <Text
          name={'dni'}
          label="Cedula"
          value={value.dni}
          onChange={(e) => {
            setValue({...value, dni: e.target.value});
          }}
        />
      </Grid>
      <Grid
        item
        xs={12}
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'flex-end',
        }}
      >
        <Button color={'primary'} variant="outlined" size="small" onClick={handleCreate}>
          Guardar
        </Button>
      </Grid>
    </Grid>
  );
}

export default function () {
  const [users, setUsers] = useState([]);
  const [showFormCreate, setShowFormCreate] = useState(false);

  const user = useSelector((state) => state.auth.user);

  const classes = useStyles();

  function getUser() {
    api.users.find({query: {$client: {company: true}, $limit: 100}}).then((it) => {
      setUsers(Object.values(it)?.filter((record) => record.id !== user?.id) ?? []);
    });
  }

  function removeUser(id) {
    api.users.remove(id).then(() => {
      getUser();
    });
  }

  function approveUser(id) {
    api.users.patch(id, {status: 'active'}).then(() => {
      getUser();
    });
  }

  useEffect(() => {
    if (user?.owner_company === 'true') getUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  console.log('[users]', users);

  return (
    <div>
      <Box className={classes.contentTitleUsers}>
        <Typography variant="subtitle1" className={clsx(classes.subtitle, classes.subtitleBold)}>
          Usuarios de la empresa
        </Typography>
        <Button variant="outlined" size="small" color="primary" onClick={() => setShowFormCreate(!showFormCreate)}>
          {showFormCreate ? 'Cancelar' : 'Crear usuario'}
        </Button>
      </Box>
      {showFormCreate && (
        <UserCreate
          onCreate={() => {
            setShowFormCreate(false);
            getUser();
          }}
        />
      )}
      {!users.length && <Typography variant="caption">No hay usuarios registrados</Typography>}
      {users.map((item, i, a) => (
        <UserItem
          disableDivider={a.length === i + 1}
          key={i}
          owner={user.owner_company === 'true'}
          source={item}
          onRemove={removeUser}
          onApprove={approveUser}
        />
      ))}
    </div>
  );
}
